import errors from "./errors";
import success from "./success";
import components from './components/index';
import diet_plan from "./diet_plan"
import routes from "./routes";
import pages from "./pages";
import global from "./global";
import forms from "./forms";
import educational from "./educational";
import topbar from "./topbar";
import autoGeneration from "./autoGeneration";
import dietPlans from "./dietPlans";
import dietPlan from "./dietPlan";
import food from "./food";
import footer from "./footer";
import auth from "./auth";
import chat from "./chat";
import tools from "./tools";
import cloud from "./cloud";
import calendar from "./calendar";
import pathisis from "./pathisis";
import massImport from "./massImport";
import admin from "./admin"
import billing from "./billing";
import shared from "./shared"
import inner from "./inner"
import fq from "./fq"
import noteHistory from "./noteHistory"
import quota from "./quota"
import financials from "./financials"
import calorieScaling from "./calorieScaling"
import growth from "./growth"
import emptyState from "./emptyState"
import apiStatus from "./apiStatus"
import commandPalette from "./commandPalette"
import newVersion from "./newVersion"

export default {
    fq,
    topbar,
    errors,
    success,
    components,
    pages,
    diet_plan,
    routes,
    global,
    forms,
    educational,
    footer,
    dietPlans,
    dietPlan,
    autoGeneration,
    food,
    auth,
    chat,
    tools,
    cloud,
    calendar,
    pathisis,
    massImport,
    admin,
    billing,
    shared,
    inner,
    noteHistory,
    quota,
    financials,
    calorieScaling,
    growth,
    emptyState,
    apiStatus,
    commandPalette,
    newVersion,
    close: 'Κλείσιμο',
    dietitian: 'Διαιτολόγος',
    copied: 'Έχει αντιγραφεί',
    minute: 'λεπτό',
    minutes: 'λεπτά',
    next: 'Επόμενο',
    back: 'Πίσω',
    click: 'κάντε κλικ εδώ',
    select: 'Κάντε μια επιλογή',
    home: 'Αρχική σελίδα',
    today: 'Σήμερα',
    month: 'Μήνας',
    week: 'Εβδομάδα',
    day: 'Ημέρα',
    meal: 'Γεύμα',
    timeGrid: 'Ημέρα',
    beta: 'Δοκιμαστική έκδοση',
    save: 'Αποθήκευση',
    skipCrop: 'Διατήρηση ως έχει',
    crop: 'Περικοπή εικόνας',
    saveChanges: 'Αποθήκευση αλλαγών',
    create: 'Δημιουργία',
    notes: 'Σημειώσεις',
    insertName: 'Εισάγετε όνομα...',
    insertNotes: 'Εισάγετε σημειώσεις...',
    datePickerPlaceholders: {
        date: "Επιλογή ημερομηνίας:",
        range: "Επιλογή εύρους ημερομηνιών",
        nextSeven: 'επόμενες 7 ημέρες',
        nextThirty: 'επόμενες 30 ημέρες',
        prevSeven: 'προηγούμενες 7 ημέρες',
        prevThirty: 'προηγούμενες 30 ημέρες'
    },
    optional: 'Προαιρετικό',
    delete: 'Διαγραφή',
    search: 'Αναζήτηση',
    searchPlaceholder: 'Αναζήτηση...',
    actions: 'Ενέργειες',
    backToLastPage: 'Επιστροφή στην τελευταία σελίδα',
    verifyDeletion: {
        title: 'Θέλετε σίγουρα να προχωρήσετε σε διαγραφή;',
        message: '<p>Η ενέργεια είναι μη αναστρέψιμη. Εάν πατήσετε διαγραφή, δεν θα μπορέσουμε με κανέναν τρόπο να επαναφέρουμε τα δεδομένα σας.' +
            '</p> <p><strong>Θέλετε σίγουρα να προχωρήσετε;</strong></p>',
        ok: 'Ναι, διαγραφή',
        cancel: 'Όχι, ακύρωση'
    },
    remove: 'Αφαίρεση',
    cancel: 'Ακύρωση',
    days: {
        monday: 'Δευτέρα',
        tuesday: 'Τρίτη',
        wednesday: 'Τετάρτη',
        thursday: 'Πέμπτη',
        friday: 'Παρασκευή',
        saturday: 'Σάββατο',
        sunday: 'Κυριακή',
        short: {
            monday: 'Δευ.',
            tuesday: 'Τρ.',
            wednesday: 'Τετ.',
            thursday: 'Πέμ.',
            friday: 'Παρ.',
            saturday: 'Σάβ.',
            sunday: 'Κυρ.',
        }
    },
    meals: {
        breakfast: 'Πρωινό',
        midBreakfast: 'Δεκατιανό',
        lunch: 'Μεσημεριανό',
        afterLunch: 'Απογευματινό',
        dinner: 'Βραδινό',
    },
    counts: {
        first: '1st',
        second: '2nd',
        third: '3rd',
        fourth: '4th',
    },
    nth: '{num}η',
    nthChoice: '{num}η Επιλογή',
    nthChoiceShort: '{num}η Επ.',
    months: {
        short: {
            january: 'Ιαν',
            february: 'Φεβ',
            march: 'Μαρ',
            april: 'Απρ',
            may: 'Μαϊος',
            june: 'Ιουν',
            july: 'Ιουλ',
            august: 'Αυγ',
            september: 'Σεπ',
            october: 'Οκτ',
            november: 'Νοε',
            december: 'Δεκ'
        }
    },
    name: 'Όνομα',
    templateName: 'Όνομα προτύπου',
    short: {
        quantity: 'Ποσ'
    },
    quantity: 'Ποσότητα',
    micro: {
        carbs: 'Υδατάνθρακες',
        proteins: 'Πρωτεϊνες',
        fats: 'Λίπη',
        cal: 'Ενέργεια',
        percentage: {
            carbs: 'Ποσοστό υδατανθράκων',
            proteins: 'Ποσοστό πρωτεϊνών',
            fats: 'Ποσοστό λίπους',
        },
        short: {
            carbs: 'Υδατ.',
            proteins: 'Πρωτ.',
            fats: 'Λίπη',
            cal: 'Ενέρ.',
        }
    },
    show: 'Εμφάνιση',
    hide: 'Απόκρυψη',
    date: 'Ημερομηνία',
    google_calendar_redirect: {
        title: 'Η σελίδα αυτή είναι μόνο για τον διατροφολόγο σας',
        text: 'Ο σύνδεσμος που ακολουθήσατε είναι η καρτέλα των στοιχείων σας και είναι μόνο προσβάσιμη από τον διατροφολόγο σας.' +
            'Εάν επιθυμείτε να χρησιμοποιήσετε το mobile app μας, παρακαλώ επικοινωνήστε με τον διατροφολόγο σας για οδηγίες!',
        dietitian: 'Είστε ο διατροφολόγος και δεν έχετε συνδεθεί;',
        button: 'Πατήστε εδώ για να συνδεθείτε'
    },
    shareACloud: 'Κοινοποίηση στο aCloud',
    aCloudCantReShare: 'Δεν μπορείτε να ξανακοινοποίησετε στο athlisis cloud.',
    aCloudViewLive: 'Προβολή του cloud πλάνου',
    copy: 'Αντιγραφή',
    paste: 'Επικόλληση',
    clear: 'Εκκαθάριση',
    editMeal: 'Επεξεργασία γεύματος',
    copyText: 'Αντιγραφή σε νέο',
    list: 'Λίστα',
    foods: 'Τρόφιμα',
    mealTemplates: {
        title: 'Πρότυπα γεύματα',
        kind: 'Είδος',
        free: 'Ελεύθερο πρότυπο',
        chooseType: 'Επίλεξε τύπο',
        chooseKind: 'Επίλεξε είδος',
        empty: 'Δεν υπάρχουν πρότυπα γεύματα ακόμα',
        emptyText: 'Αποθήκευσε ένα γεύμα ως πρότυπο για να το ξαναχρησιμοποιείς στα πλάνα σου.',
        noMatch: 'Δεν βρέθηκαν πρότυπα γεύματα'
    },
    chooseCustomer: 'Επιλογή πελάτη',
    copyToTemplate: 'Αντιγραφή σε νέο πρότυπο',
    copyToAthlete: 'Αντιγραφή σε πελάτη',
    copyTemplate: 'Αντιγραφή προτύπου',
    saveTemplate: 'Αποθήκευση ως πρότυπο',
    importTemplate: 'Εισαγωγή από πρότυπο',
    sendByMail: 'Αποστολή με e-mail',
    emailSubject: 'Θέμα e-mail',
    description: 'Περιγραφή',
    aCloudName: 'Το όνομα που θα υπάρχει στο cloud',
    chooseTagsACloud: 'Επιλέξτε ετικέτες (τουλάχιστον 1)',
    reset: 'Επαναφορά',
    total: 'Σύνολο',
    saveAsCsv: 'Αποθήκευση ως CSV',
    isOffline:'Δεν έχετε πρόσβαση στο Internet',
    backOnline: 'Η σύνδεση στο Internet αποκαταστάθηκε',
    sent: 'Έχει αποσταλεί',
    selected: 'επιλεγμένα',
    selectAll: 'Επιλογή όλων',
    deselectAll: 'Αποεπιλογή όλων',
    safariInstructions: '     Επειδή χρησιμοποιείτε Safari, <a\n' +
        '        href="https://athlisis-new.s3.eu-north-1.amazonaws.com/athlisis_safari_print_e2dbe5442e.pdf" target="_blank"\n' +
        '    >\n' +
        '      παρακαλώ ακολουθήστε τις οδηγίες για ορθή εκτύπωση κάνοντας κλικ εδώ.\n' +
        '    </a>',
    tbw: 'TBW (Συνολικά υγρά σώματος)',
    weeklyExercise: 'Εβδομαδιαία άσκηση',
    templatePlan: 'Πρότυπο διατροφικό πλάνο',
    notifications: {
        title: 'Ενημερώσεις',
        noNotifications: 'Δεν υπάρχουν ενημερώσεις',
        noNotificationsText: 'Τα νέα και οι ανακοινώσεις του athlisis θα εμφανίζονται εδώ.'
    },
    eg: 'π.χ. {value}',
    measure: 'Μέτρηση',
    measures: {
        title: 'Μεζούρες'
    },
    student: {
        label: 'Εκπαιδευτικός λογαριασμός'
    }
}
